module.exports = __webpack_public_path__ + "static/favicon-0337296707d1f60ff25e811c4edc73b3.png";